import { render, staticRenderFns } from "./SummaryInformation.vue?vue&type=template&id=33ddba98"
import script from "./SummaryInformation.vue?vue&type=script&lang=js"
export * from "./SummaryInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports